module.exports = __webpack_public_path__ + "static/media/image5.4f85c7ed.jpg";